import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Route, Routes, BrowserRouter } from 'react-router-dom';
import AltiPage from './sections/AltiPage';
import CanopyPage from './canopyFlight/CanopyPage2';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <Routes>
      <Route index path={"/:club?/:article?"} element={(<App />)} />
      <Route path={"/altimiter"} element={(<AltiPage />)} />
      <Route path={"/canopy"} element={(<CanopyPage />)} />
    </Routes>
  </BrowserRouter>
);


//  <React.StrictMode>
//  </React.StrictMode>

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
